import footerJson from './footer.json'
import { FooterNavListWrapper } from './footerNavListParts'
import FooterNavListSection, { type Footer } from './footerNavListSection'
import Logo from './gsmaLogo'
import { SocialButtons } from './socialButtons'

export default function FooterComponent() {
	return (
		<footer className="bg-gsma-gray-03 ">
			<div className="bg-gsma-gray-0 w-full px-4 py-14 md:px-0">
				<div className="container grid grid-cols-2 gap-6 md:grid-cols-6 mx-auto">
					<GsmaLogo />
					<FooterSectionItems />
					<ContainerisedFooterSection />
				</div>
			</div>
			<Copyright />
		</footer>
	)
}

function FooterSectionItems() {
	const footerSectionItems = footerJson.footer.filter(
		(item) => item.containerId === 0
	) as Footer[]
	return footerSectionItems.map((item, index) => (
		<FooterNavListSection key={index} footerList={item} />
	))
}

function ContainerisedFooterSection() {
	const containerisedFooterSectionItems = footerJson.footer.filter(
		(item) => item.containerId === 1
	) as Footer[]
	return (
		<FooterNavListWrapper>
			{containerisedFooterSectionItems.map((item, index) => (
				<FooterNavListSection key={index} footerList={item} />
			))}
			<SocialButtons />
		</FooterNavListWrapper>
	)
}

function GsmaLogo() {
	return (
		<div className="col-span-2 mr-8 pb-10 md:col-span-1">
			<h3>
				<a
					href="https://www.gsma.com/"
					target="_blank"
					rel="noreferrer"
				>
					<Logo className="h-5 md:w-[70%]" />
				</a>
			</h3>
		</div>
	)
}

function Copyright() {
	return (
		<div className="items-left flex w-full flex-col justify-center px-4 py-10 md:px-[12%]">
			<p className="text-left text-[60%] text-black">
				© Copyright 2026 GSM Association.The GSM logo is registered and
				owned by the GSM Association.
			</p>
		</div>
	)
}
